import { Layers, Info } from "lucide-react";
import { CONVENIO_DATA, formatBRL } from "@/data/financeData";

export const ConvenioComparison = () => {
  const best = Math.max(...CONVENIO_DATA.map((c) => c.margem));
  return (
    <div className="rounded-2xl border border-slate-200/70 bg-white p-5 shadow-[0_2px_8px_rgba(0,0,0,0.04)] md:p-6">
      <div className="mb-5 flex items-center gap-2">
        <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-indigo-50">
          <Layers className="h-4 w-4 text-indigo-600" />
        </div>
        <div>
          <h2 className="font-heading text-base font-bold text-slate-900">
            Margem por Convênio
          </h2>
          <p className="text-xs text-slate-500">Particular vs. convênios — margem líquida</p>
        </div>
      </div>

      <div className="space-y-4" data-testid="convenio-comparison">
        {CONVENIO_DATA.map((c) => {
          const isBest = c.margem === best;
          const isLow = c.margem < 50;
          return (
            <div key={c.name} data-testid={`convenio-${c.id}`}>
              <div className="mb-1.5 flex items-center justify-between text-sm">
                <div className="flex items-center gap-2">
                  <span className="h-2.5 w-2.5 rounded-full" style={{ background: c.color }} />
                  <span className="font-semibold text-slate-800">{c.name}</span>
                  {isBest && (
                    <span className="rounded-full bg-emerald-50 px-1.5 py-0.5 text-[10px] font-bold text-emerald-600">
                      melhor margem
                    </span>
                  )}
                  {isLow && (
                    <span className="rounded-full bg-rose-50 px-1.5 py-0.5 text-[10px] font-bold text-rose-600">
                      atenção
                    </span>
                  )}
                </div>
                <div className="flex items-center gap-3">
                  <span className="text-xs text-slate-400">{c.volume}% volume</span>
                  <span className="font-mono-num text-sm font-bold text-slate-900">{c.margem}%</span>
                </div>
              </div>
              <div className="h-2.5 w-full overflow-hidden rounded-full bg-slate-100">
                <div
                  className="h-full rounded-full transition-all duration-500"
                  style={{ width: `${c.margem}%`, background: c.color }}
                />
              </div>
              <p className="mt-1 text-right font-mono-num text-[11px] text-slate-400">
                {formatBRL(c.faturamento)}
              </p>
            </div>
          );
        })}
      </div>

      <div className="mt-5 flex items-start gap-2 rounded-xl border border-rose-200/60 bg-rose-50/50 p-3">
        <Info className="mt-0.5 h-3.5 w-3.5 shrink-0 text-rose-500" />
        <p className="text-xs leading-relaxed text-rose-700">
          A <strong>Unimed</strong> concentra o maior volume, porém com a menor margem. Priorizar
          atendimentos Particulares eleva a rentabilidade da clínica.
        </p>
      </div>
    </div>
  );
};
